import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ENV } from '@/utils/env';
import { DocumentationButton, PanelSubTitle, PanelText, PanelTitle, TitleContainer } from './WebhookPanel.style';

const RESTAURANT_WEBHOOK_DOC_URL = `${ENV.STATIC_URL}/dashboard/webhook-notification-doc.pdf`;
const BRAND_WEBHOOK_DOC_URL = `${ENV.STATIC_URL}/dashboard/notifications_webhook_brand_doc.pdf`;

export interface WebhookPanelProps {
    isBrandLevel?: boolean;
}

const WebhookPanel: React.FunctionComponent<React.PropsWithChildren<WebhookPanelProps>> = ({
    isBrandLevel = false,
}) => {
    const titleKey = isBrandLevel ? 'webhook.brand.title' : 'webhook.title';
    const firstSubtitleKey = isBrandLevel ? 'webhook.brand.firstpart.subtitle' : 'webhook.firstpart.subtitle';
    const firstDescriptionKey = isBrandLevel ? 'webhook.brand.firstpart.description' : 'webhook.firstpart.description';
    const secondSubtitleKey = isBrandLevel ? 'webhook.brand.secondpart.subtitle' : 'webhook.secondpart.subtitle';
    const secondDescriptionKey = isBrandLevel
        ? 'webhook.brand.secondpart.description'
        : 'webhook.secondpart.description';

    // Use different documentation URLs based on webhook type
    const documentationUrl = isBrandLevel ? BRAND_WEBHOOK_DOC_URL : RESTAURANT_WEBHOOK_DOC_URL;

    return (
        <div>
            <TitleContainer>
                <PanelTitle text={titleKey} />
            </TitleContainer>
            <PanelSubTitle text={firstSubtitleKey} weight="bold" />
            <PanelText text={firstDescriptionKey} />
            <PanelSubTitle text={secondSubtitleKey} weight="bold" />
            <PanelText text={secondDescriptionKey} />
            <a href={documentationUrl} target="_BLANK" rel="noopener noreferrer">
                <DocumentationButton buttonType="primary">
                    <FormattedMessage id="webhook.documentationLink" />
                </DocumentationButton>
            </a>
        </div>
    );
};

export default WebhookPanel;
